import { render, staticRenderFns } from "./restrictAccess.vue?vue&type=template&id=340edddf&scoped=true&"
import script from "./restrictAccess.vue?vue&type=script&lang=js&"
export * from "./restrictAccess.vue?vue&type=script&lang=js&"
import style0 from "./restrictAccess.vue?vue&type=style&index=0&id=340edddf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340edddf",
  null
  
)

export default component.exports